import { render, staticRenderFns } from "./zhongjianye.vue?vue&type=template&id=20209048&scoped=true"
import script from "./zhongjianye.vue?vue&type=script&lang=js"
export * from "./zhongjianye.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20209048",
  null
  
)

export default component.exports